// sentry должна импортироваться как можно раньше
import './sentry-browser-setup';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment, HOST } from '@core/const';
import { AppBrowserModule } from './app/app.browser.module';

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic([
    {
      provide: HOST,
      useValue: window.location.host,
    },
  ])
    .bootstrapModule(AppBrowserModule)
    .catch((err: unknown) => console.error(err));
});
